// Current-week aggregate evidence belongs to the service layer, not mounted pages.
const TTL_MS = 60_000;
const entries = new Map();
const aliases = new Map();
const pending = new Map();
const listeners = new Set();
let generation = 0;

export const weeklyCacheGeneration = () => generation;
export function subscribeWeeklyCache(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
export function invalidateProjectWeekly() {
  generation++;
  entries.clear();
  aliases.clear();
  pending.clear();
  for (const listener of listeners) listener();
}
export function weeklyEvidenceKey(idsKey, authIdentity, week) {
  return JSON.stringify([authIdentity, idsKey, week || "current"]);
}
export function getWeeklyEvidence(key, allowStale = false) {
  const entry = entries.get(aliases.get(key) || key);
  if (!entry || Date.now() >= entry.weekEnd || (!allowStale && Date.now() >= entry.expires)) return null;
  return entry.data;
}
export function loadWeeklyEvidence(key, loader) {
  const cached = getWeeklyEvidence(key);
  if (cached) return Promise.resolve(cached);
  if (pending.has(key)) return pending.get(key);
  const started = generation;
  const promise = Promise.resolve().then(loader).then(data => {
    if (started !== generation) throw new Error("Weekly counts changed while loading. Please retry.");
    // The clock only bounds expiry; it never selects a week. The server does.
    const weekEnd = Date.parse(`${data.weekDate}T00:00:00Z`) + 7 * 86400000;
    const canonicalKey = JSON.stringify([...JSON.parse(key).slice(0, 2), data.weekDate]);
    entries.set(canonicalKey, { data, weekEnd, expires: Math.min(Date.now() + TTL_MS, weekEnd) });
    aliases.set(key, canonicalKey);
    return data;
  }).finally(() => {
    if (pending.get(key) === promise) pending.delete(key);
  });
  pending.set(key, promise);
  return promise;
}
